import { type FC, useCallback, useMemo } from 'react';

import { Hvc } from '../components';
import { TypeSelect } from '../select';
import { SelectedItems } from './selected-items';
import type { ITypeMultiSelect } from './utils';

const TypeMultiSelect: FC<ITypeMultiSelect> = ({
	selectedItems,
	setSelectedItems,
	hideSelected,
	minComponent,
	...selectProps
}) => {
	const { optionsdata, value: selectedValue } = selectProps;

	// const [selectedValue, setSelectedValue] = useState<
	//   string | number | readonly string[] | undefined
	// >('')

	const onAddItem = (value: typeof selectedValue) => {
		if (!value) return;
		// setSelectedValue('')
		const selectedItem = optionsdata?.filter((i) => i.value === value)?.[0];
		if (!selectedItem) return;
		setSelectedItems?.([...selectedItems, selectedItem]);
	};

	const onRemoveItems = useCallback(
		(id: string | number) => {
			if (!id) return;
			setSelectedItems?.([...selectedItems.filter((i) => i.id !== id)]);
		},
		[selectedItems, setSelectedItems]
	);

	// `optionsdata` must stay in the deps: it usually arrives from a fetch AFTER the
	// first render, while `selectedItems` (a react-hook-form value) keeps a stable
	// identity — so omitting it froze this memo on the initial `undefined` and the
	// select rendered nothing but its init option, refresh button included.
	const filteredSelectedItems = useMemo(() => {
		if (!selectedItems.length) return optionsdata;
		const filtered = optionsdata?.filter((i) => !selectedItems.map((j) => j.id).includes(i.id));
		return filtered ?? [];
	}, [optionsdata, selectedItems]);

	return (
		<div className='f-column-7'>
			<TypeSelect
				{...selectProps}
				optionsdata={filteredSelectedItems}
				minComponent={minComponent}
				// value={selectedValue}
				onChange={(e) => {
					onAddItem(e.target.value);
				}}
			/>
			<Hvc
				removeDOM
				view={!hideSelected && !!selectedItems?.length}
			>
				<SelectedItems
					items={selectedItems}
					onRemove={onRemoveItems}
				/>
			</Hvc>
		</div>
	);
};

export default TypeMultiSelect;
